import { compose, mapProps } from 'recompose'
import withEntity from '../../context/with-entity'
import withCharityDomain from './withCharityDomain'
import withTranslations from '../../core/withTranslations'
import withCharitySocialMedia from './withCharitySocialMedia'
import capitalize from 'lodash/capitalize'
import CharityDetail from '../../ui/views/charity-detail'

const translations = withTranslations({
  locationText: 'common:location',
  viewMapText: 'common:viewMap',
  contactWithUsText: 'common:contactWithUs',
  ourMisionText: 'app:charity.ourMission',
  ourEventsText: 'app:charity.ourEvents',
  ourItemsText: 'app:charity.ourItems',
  contactText: 'common:contact'
})

const withData = mapProps(props => {
  return {
    charity: props.entity,
    ourEventsLink: `/charities/${props.entity.id}/auctions`,
    ourItemsLink: `/charities/${props.entity.id}/items`,
    contactLink: `/charities/${props.entity.id}/contact`,
    // translations
    locationText: capitalize(props.locationText),
    viewMapText: capitalize(props.viewMapText),
    contactWithUsText: capitalize(props.contactWithUsText),
    ourMisionText: props.ourMisionText,
    ourEventsText: props.ourEventsText,
    ourItemsText: props.ourItemsText,
    contactText: capitalize(props.contactText)
  }
})

export const CharityDetailEnhancer = compose(
  translations,
  withCharityDomain,
  withEntity,
  withData,
  withCharitySocialMedia
)

export default CharityDetailEnhancer(CharityDetail)



// WEBPACK FOOTER //
// ./src/services/charity/CharityDetail.js